module.exports = __webpack_public_path__ + "img/icon-package-ekyc-validation-light.b57ac6d.svg";